import { render } from "./App.vue?vue&type=template&id=29cc21ae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=29cc21ae&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\小言子\\项目\\全民展演\\pc\\aiyueceng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__